<!-- src/app/pages/senate/senate.html -->

<main class="senate-page">

  <!-- HERO -->
  <section class="senate-hero">
    <div class="senate-container">

      <div class="senate-hero__content">

        <p class="eyebrow">
          Michigan • U.S. Senate • 2026
        </p>

        <h1>
          Lydia Christensen for U.S. Senate
        </h1>

        <p class="senate-hero__subtitle">
          Michigan's Unchained Voice
        </p>

        <p class="senate-hero__intro">
          Lydia Christensen is an American political candidate from Michigan
          running for <strong>the United States Senate in 2026</strong>.
          She is the Libertarian candidate for U.S. Senate in Michigan.
        </p>

        <div class="senate-hero__actions">
          <a routerLink="/about" class="btn btn-primary">
            Meet Lydia
          </a>

          <a routerLink="/issues" class="btn btn-secondary">
            Explore the Issues
          </a>
        </div>

      </div>

      <div class="senate-hero__image">
        <img
          src="assets/bannerFinalizedNoStars.png"
          alt="Lydia Christensen for U.S. Senate in Michigan"
          width="1200"
          height="630"
          fetchpriority="high"
        />
      </div>

    </div>
  </section>


  <!-- INTRO -->
  <section class="senate-section">
    <div class="senate-container senate-container--narrow">

      <p class="section-label">
        U.S. Senate — Michigan
      </p>

      <h2>
        Lydia Christensen is running for U.S. Senate in Michigan
      </h2>

      <p>
        Lydia Christensen is an American political candidate from Michigan
        running for the United States Senate in the 2026 election. She is the
        Libertarian candidate for U.S. Senate in Michigan and is campaigning
        across the state.
      </p>

      <p>
        The campaign is headquartered in Ironwood, Michigan, and is focused
        on bringing an independent voice from Michigan's Upper Peninsula
        and communities throughout the state to the U.S. Senate.
      </p>

    </div>
  </section>


  <!-- CANDIDATE -->
  <section class="senate-section senate-section--alt">
    <div class="senate-container">

      <div class="senate-grid">

        <div>
          <p class="section-label">
            Meet Lydia
          </p>

          <h2>
            Who is Lydia Christensen?
          </h2>

          <p>
            Lydia Christensen is an American political candidate, technology
            founder, and Libertarian candidate for the United States Senate
            in Michigan. Her campaign is based in Ironwood in Michigan's
            Upper Peninsula.
          </p>

          <p>
            She is running for the United States Senate because she believes
            Michigan should have an independent voice in Washington and that
            voters should have choices beyond the two major parties.
          </p>

          <a routerLink="/about" class="text-link">
            Learn more about Lydia →
          </a>
        </div>

        <div class="info-card">

          <div class="info-card__row">
            <span>Candidate</span>
            <strong>Lydia Christensen</strong>
          </div>

          <div class="info-card__row">
            <span>Office</span>
            <strong>United States Senate</strong>
          </div>

          <div class="info-card__row">
            <span>State</span>
            <strong>Michigan</strong>
          </div>

          <div class="info-card__row">
            <span>Election</span>
            <strong>2026</strong>
          </div>

          <div class="info-card__row">
            <span>Party</span>
            <strong>Libertarian</strong>
          </div>

        </div>

      </div>

    </div>
  </section>


  <!-- ISSUES -->
  <section class="senate-section">
    <div class="senate-container">

      <div class="section-heading">
        <p class="section-label">
          Campaign Platform
        </p>

        <h2>
          Issues important to Michigan
        </h2>

        <p>
          Explore the policies and issues Lydia Christensen has developed
          as a candidate for U.S. Senate.
        </p>
      </div>

      <div class="issue-links">

        <a routerLink="/issues" class="issue-card">
          <span class="issue-card__title">
            Campaign Issues
          </span>

          <span class="issue-card__text">
            Read Lydia's positions on issues affecting Michigan and the
            United States.
          </span>

          <span class="issue-card__arrow">→</span>
        </a>

        <a routerLink="/compare" class="issue-card">
          <span class="issue-card__title">
            Compare Candidates
          </span>

          <span class="issue-card__text">
            Review candidate positions and differences on issues before
            making your decision.
          </span>

          <span class="issue-card__arrow">→</span>
        </a>

        <a routerLink="/report-card" class="issue-card">
          <span class="issue-card__title">
            Legislative Report Card
          </span>

          <span class="issue-card__text">
            Review the campaign's assessment of congressional votes and
            legislative records.
          </span>

          <span class="issue-card__arrow">→</span>
        </a>

      </div>

    </div>
  </section>


  <!-- MICHIGAN -->
  <section class="senate-section senate-section--dark">
    <div class="senate-container senate-container--narrow">

      <p class="section-label">
        Michigan's U.S. Senate Race
      </p>

      <h2>
        A campaign rooted in Michigan
      </h2>

      <p>
        From the Upper Peninsula to Southeast Michigan, the campaign is
        building a statewide organization focused on reaching voters
        directly in their communities.
      </p>

      <div class="state-facts">

        <div class="state-fact">
          <strong>Michigan</strong>
          <span>State represented</span>
        </div>

        <div class="state-fact">
          <strong>U.S. Senate</strong>
          <span>Office sought</span>
        </div>

        <div class="state-fact">
          <strong>2026</strong>
          <span>Election year</span>
        </div>

      </div>

    </div>
  </section>


  <!-- GET INVOLVED -->
  <section class="senate-section">
    <div class="senate-container">

      <div class="section-heading">
        <p class="section-label">
          Get Involved
        </p>

        <h2>
          Take part in the campaign
        </h2>

        <p>
          Learn how you can volunteer, attend events, support the campaign,
          or stay informed about Lydia Christensen's campaign for U.S.
          Senate in Michigan.
        </p>
      </div>

      <div class="action-grid">

        <a routerLink="/volunteer" class="action-card">
          <h3>Volunteer</h3>
          <p>
            Help the campaign reach voters across Michigan.
          </p>
          <span>Get involved →</span>
        </a>

        <a routerLink="/events" class="action-card">
          <h3>Events</h3>
          <p>
            Find upcoming campaign events and opportunities to meet Lydia.
          </p>
          <span>View events →</span>
        </a>

        <a routerLink="/newsroom" class="action-card">
          <h3>Newsroom</h3>
          <p>
            Read campaign announcements, statements, and press releases.
          </p>
          <span>Read the newsroom →</span>
        </a>

        <a routerLink="/contact" class="action-card">
          <h3>Contact</h3>
          <p>
            Get in touch with the campaign.
          </p>
          <span>Contact the campaign →</span>
        </a>

      </div>

    </div>
  </section>


  <!-- FINAL CTA -->
  <section class="senate-final">
    <div class="senate-container senate-container--narrow">

      <p class="section-label">
        Lydia Christensen for U.S. Senate
      </p>

      <h2>
        Unchain Michigan
      </h2>

      <p>
        Follow Lydia Christensen's campaign for United States Senate
        in Michigan in 2026.
      </p>

      <div class="senate-hero__actions">
        <a routerLink="/about" class="btn btn-primary">
          Meet Lydia
        </a>

        <a routerLink="/volunteer" class="btn btn-secondary">
          Volunteer
        </a>
      </div>

    </div>
  </section>

</main>